import { NavigateOptions, To } from 'react-router-dom';

// Navigate via custom event to support navigation from non-component code
export const navigateEvent = (to: To, options?: NavigateOptions) => {
  window.dispatchEvent(new CustomEvent('navigate', { detail: { to, options } }));
};

